import React from "react";

const FatsuOriginSkeleton: React.FC = () => {
  return (
    <div>
      <div className="h-14 max-sm:h-8 max-sm:w-full w-96 max-md:w-56 skeleton"></div>
      <div className="max-md:grid-cols-1">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((item) => {
          return (
            <div
              key={item}
              className="skeleton w-full h-6 my-5"
            ></div>
          );
        })}
      </div>
    </div>
  );
};
export default FatsuOriginSkeleton;
